import ganalytics from './ganalytics'
import stepAnimations from './stepAnimations'
import toolbar from './toolbar'

export default {
  build: function (storyboard) {
    let html = ''
    storyboard.containers.annotations.forEach(function (annotation) {
      annotation.steps.forEach(function (step) {
        const stepClass = 'step'
        let label = step.label || ''
        html += `
          <li id="step-${step.stepNumber}"  class="${stepClass}" data-image="${step.image}" data-step="${step.stepIndex}"" data-step-global="${step.stepNumber}">
            <div class="step-thumb" style="background-image: url(${step.thumbnail});"></div>
            <div class="step-number">
                ${step.stepNumber}.
            </div>
            <div class="step-label">
                ${label}
            </div>
          </li>`
      })
    })

    storyboard.DOM.stepList.innerHTML = html

    storyboard.DOM.steps = document.querySelectorAll('.step')
    let that = this
    storyboard.DOM.steps.forEach(function (step) {
      ganalytics.attachAnalyticsToCustomButton(
        document.getElementById('step-' + step.getAttribute('data-step-global')),
        'goto-step',
        storyboard.metadata,
        storyboard.metadata.customerCode
      )

      step.addEventListener('click', function (e) {
        e.preventDefault()
        let prevImage = storyboard.stepper.currentImage

        storyboard.stepper.currentImage = parseInt(this.dataset.image)
        storyboard.stepper.currentAnimationStep = parseInt(this.dataset.step)
        storyboard.stepper.currentGlobalAnimationStep = parseInt(this.dataset.stepGlobal)

        that.close(storyboard)

        let to = setTimeout(function () {
          clearTimeout(to)

          if (prevImage !== storyboard.stepper.currentImage) {
            storyboard.changePage()
          } else {
            let to2 = setTimeout(function () {
              clearTimeout(to2)
              stepAnimations.animate(storyboard)
            }, storyboard.stepper.directStepAnimationDelay)
          }
        }, storyboard.stepper.directChangePageDelay)
      })
    })
  },

  close: function (storyboard) {
    storyboard.DOM.stepListContainer.classList.add('hidden')
    storyboard.DOM.navigatorAutoHideEnabled = true
    toolbar.showButtons(storyboard)
  }
}
